import $$ from '@/store/plugins/storage'

const namespace = 'global'
$$.setNamespace(namespace)

const state = {
  serviceSize: [
    { id: 1, name: '1-5人' },
    { id: 2, name: '6-10人' },
    { id: 3, name: '11-20人' },
    { id: 4, name: '21-30人' },
    { id: 5, name: '31-50人' },
    { id: 6, name: '51-100人' },
    { id: 7, name: '101-200人' },
    { id: 8, name: '201-500人' },
    { id: 9, name: '500人以上' },
  ],
  serviceLevel: ['A', 'B', 'C', 'D'],
  userCategory: [
    { id: 0, name: '免费版' },
    { id: 1, name: 'VIP版' },
    { id: 2, name: 'VIP试用版' },
    { id: 3, name: '免费规格版' },
  ],
  is_usageArr: [
    { id: '', name: '全部' },
    { id: 1, name: '在用' },
    { id: 0, name: '停用' },
  ],
  is_renewArr: [
    { id: 1, name: '是' },
    { id: 0, name: '否' },
    { id: 2, name: '待定' },
  ],
  sourceList: [
    { id: 1, name: '点评' },
    { id: 2, name: '单小二' },
    { id: 3, name: '抖音' },
  ],
  skuTypeList: [
    { id: 'az', name: '安装' },
    { id: 'qx', name: '清洗' },
    { id: 'wx', name: '维修' },
    { id: 'bj', name: '保洁' },
  ],
  orderStatusList: [
    { id: 0, name: '初始化' },
    { id: 100, name: '待支付' },
    { id: 101, name: '订单关闭' },
    { id: 200, name: '支付成功' },
    { id: 201, name: '待使用' },
    { id: 1, name: '交易成功' },
  ],
}

const mutations = {}

const getters = {
  getSelectState: (state) => (id, stateName) => {
    return state[stateName].find((v) => v.id === id) || {}
  },
}

export default { namespaced: true, state, mutations, getters }



// WEBPACK FOOTER //
// ./src/store/modules/global.js